import FieldUser, {ADD_USER} from "../../../../fields3/generic/user/user"
import FieldConfig from "../../../proto/field-config"
import FieldEventAssignedUser_GoalListEditable from "./render/goal-list-editable"
import FieldEventAssignedUser_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldEventAssignedUser_GoalListView from "./render/goal-list-view"
import ItemModel from "../../../../model2/item/item-model"
import TableManager from "../../../../gd-modules/table/manager/table-manager"
import TaskListManager from "../../../../gd-modules/task-list/manager/manager"
import {LifecycleAction} from "../../../../gd/const/lifecycle"

export default class FieldEventAssignedUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Event Assigned User";
        this.label      = "Assigned to"

        this.components.PickerValueNotEmpty     = FieldEventAssignedUser_PickerValueNotEmpty

        this.renderComponents.goalListEditable  = FieldEventAssignedUser_GoalListEditable
        this.renderComponents.goalListView      = FieldEventAssignedUser_GoalListView

        this.fieldParams.tableCellOnValueChange     = this.tableCellOnValueChange

        this.noValueOption  = true
    }

    // we know projectId so need specific users only here
    getOptionsForEdit(model:any) {
        const projectId = _.get(model, 'projectId', null)

        if (projectId) {
            const projectUsers = gd.session.projectUsers.filterByProject(projectId);
            return projectUsers.map((projectUser:any)=>{
                return {
                    value: projectUser.user.id,
                    label: projectUser.user.name
                }
            })
        }

        return this.getOptions()
    }

    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {


        /*// Special case whn add a user
        if (value === ADD_USER) {
            item.task.addUserAsAssignee()
            return
        }*/


        item.event.assignedToUserId = value
        item.event.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // need it because of workday duration depends on Assignee
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }
}
